import { UserOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import React from 'react';
import { PersonProfileImage } from 'zComponents/atoms';
import { Avatar, Card, Flex, Typography } from 'zui/Antd';

const { Title } = Typography;

const ActionCardHome = ({
	image,
	photoUrl,
	title,
	subtitle,
	size = 85,
	description,
	shape = 'square',
	extra,
	onClick
}) => {
	const {
		token: { fontWeightStrong, colorTextLabel, colorPrimary, fontSize, paddingLG, colorBorder }
	} = theme.useToken();

	return (
		<Card
			style={{
				cursor: 'pointer',
				height: '140px',
				width: '100%',
				border: `1px solid ${colorBorder}`
			}}
			styles={{
				body: {
					padding: paddingLG,
					height: '100%',
					display: 'flex',
					alignItems: 'center'
				}
			}}
			theme={{ colorPrimary }}
			onClick={onClick}
		>
			<Flex align='center' gap={paddingLG} style={{ width: '100%' }}>
				{/* Image */}
				<Flex style={{ flexShrink: 0 }}>
					{photoUrl ? (
						<PersonProfileImage
							size={size}
							photoUrl={photoUrl}
							entityName={'People'}
							shape={shape}
							edit={false}
						/>
					) : (
						<Avatar
							size={size}
							icon={<UserOutlined />}
							src={image}
							style={{ width: size, height: size }}
							shape={shape}
						/>
					)}
				</Flex>

				{/* Text Content */}
				<Flex vertical style={{ flex: 1, minWidth: 0 }}>
					{/* Title */}
					{title && (
						<Title
							style={{
								fontWeight: fontWeightStrong,
								margin: 0,
								marginBottom: 8
							}}
							level={3}
							ellipsis={{ rows: 1 }}
						>
							{title}
						</Title>
					)}
					{/* Subtitle */}
					{subtitle && (
						<Title
							style={{
								fontWeight: fontWeightStrong,
								color: colorTextLabel,
								margin: 0,
								marginBottom: 8
							}}
							level={5}
							ellipsis={{ rows: 1 }}
						>
							{subtitle}
						</Title>
					)}
					{/* description */}
					{description && (
						<Title
							style={{
								fontWeight: 400,
								color: colorTextLabel,
								margin: 0,
								fontSize: fontSize,
								lineHeight: '22px'
							}}
							ellipsis={{ rows: 2 }}
						>
							{description}
						</Title>
					)}
					{/* Extra */}
					{extra && extra}
				</Flex>
			</Flex>
		</Card>
	);
};

export default ActionCardHome;
